import { api } from '../../services/api';
import { HRRequest, CreateHRRequest } from '../../types/ess';

export const requestApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getMyRequests: builder.query<HRRequest[], string>({
            query: (employeeId) => `/v1/requests/my/${employeeId}`,
            providesTags: (result) =>
                result
                    ? [
                        ...result.map(({ id }) => ({ type: 'Request' as const, id })),
                        { type: 'Request', id: 'LIST' },
                    ]
                    : [{ type: 'Request', id: 'LIST' }],
        }),
        getAllRequests: builder.query<HRRequest[], void>({
            query: () => '/v1/requests',
            providesTags: (result) =>
                result
                    ? [
                        ...result.map(({ id }) => ({ type: 'Request' as const, id })),
                        { type: 'Request', id: 'LIST' },
                    ]
                    : [{ type: 'Request', id: 'LIST' }],
        }),
        // Sidebar dot: how many are waiting and when the newest arrived (HR/admin only).
        getPendingRequestsSummary: builder.query<{ pending: number; latestPendingAt: string | null }, void>({
            query: () => '/v1/requests/pending-summary',
            providesTags: [{ type: 'Request', id: 'LIST' }],
        }),
        createRequest: builder.mutation<HRRequest, CreateHRRequest>({
            query: (data) => ({
                url: '/v1/requests',
                method: 'POST',
                data,
            }),
            // 'Activity' too: the Request Center table and the dashboard's recent
            // activity are the ESS activity feed, not the requests list.
            invalidatesTags: [{ type: 'Request', id: 'LIST' }, 'Activity' as any],
        }),
        processRequest: builder.mutation<HRRequest, { id: string; status: 'approved' | 'rejected'; comments?: string }>({
            query: ({ id, ...data }) => ({
                url: `/v1/requests/${id}/process`,
                method: 'PATCH',
                data,
            }),
            invalidatesTags: (result, error, { id }) => [{ type: 'Request', id }, { type: 'Request', id: 'LIST' }, 'Activity' as any],
        }),
    }),
});

export const {
    useGetMyRequestsQuery,
    useGetAllRequestsQuery,
    useGetPendingRequestsSummaryQuery,
    useCreateRequestMutation,
    useProcessRequestMutation,
} = requestApi;
